<script lang="ts">
    import { _ } from 'svelte-i18n';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { onMount } from 'svelte';
    import { debug, mainMenu, planning } from '../../../stores/store';
    import GanttCouriers from './GanttCouriers.svelte';
    import TemplateHeaderUno from '../../shared/TemplateHeaderUno.svelte';
    import { GanttCouriersSettings, GanttCouriersSettingsModeType } from './GanttCouriersSettings';
    import Switch from '../../shared/Switch.svelte';
    import Select from '../../shared/Select.svelte';
    import { ScenarioApi } from '../Planning/ScenarioApi';
    import { api, customerSettings } from '../../../stores/api';
    import { AssignmentApi } from '../Planning/AssignmentApi';
    import SelectDay from '../../shared/SelectDay.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';

    let ganttCouriersSettings = new GanttCouriersSettings();

    onMount(() => {
        $mainMenu.currentPage = 'PageGanttCouriers';
        ganttCouriersSettings
            .setSimpleView(false)
            .setAssignmentIds([])
            .setSelectedDay($planning.selectedDay)
            .setUseDumpApi(true)
            .setRouteStopTimes(
                $customerSettings.each_stop_minutes,
                $customerSettings.each_delivery_minutes
            )
            .setMode(GanttCouriersSettingsModeType.APPROACHED);
        ganttCouriersSettings = ganttCouriersSettings;
        console.log('PageGanttCouriers mounted');

        // ScenarioApi.getOneForDay($api, $planning.selectedDay)
        //     .then(scenario => {
        //         if (scenario) {
        //             AssignmentApi.getByScenarioId($api, scenario.id).then(ass => {
        //                 ganttCouriersSettings
        //                     .setSimpleView(false)
        //                     .setAssignmentIds(ass.map(a => a.id))
        //                     .setRouteStopTimes(
        //                         $customerSettings.each_stop_minutes,
        //                         $customerSettings.each_delivery_minutes
        //                     )
        //                     .setMode(GanttCouriersSettingsModeType.APPROACHED);
        //                 ganttCouriersSettings = ganttCouriersSettings;
        //             });
        //         } else {
        //             console.warn('Not found scenario for day', $planning.selectedDay);
        //         }
        //     })
        //     .catch(e => {
        //         console.error('PageGanttCouriers', e);
        //     });
    });
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderUno>
            <div slot="main-header">
                {$_('gantt-header')}
            </div>
        </TemplateHeaderUno>
    </div>
    <div slot="content-header"></div>
    <div slot="monit"></div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <div
            style="display: flex; align-items: center; justify-content: flex-end; margin: 10px 0 5px 0;"
        >
            {#if ganttCouriersSettings.isSetSelectedDay()}
                <SelectDay
                    day={ganttCouriersSettings.getSelectedDay()}
                    showRelativeToday={false}
                    onChange={day => {
                        console.log('SelectDay onChange', day);
                        ganttCouriersSettings.setSelectedDay(day);
                        ganttCouriersSettings.tickCounter();
                        ganttCouriersSettings = ganttCouriersSettings;
                        return true;
                    }}
                />
                <ButtonSmallBlack
                    text={$_('refresh_view')}
                    on:click={() => {
                        ganttCouriersSettings.tickCounter();
                        ganttCouriersSettings = ganttCouriersSettings;
                        return true;
                    }}
                />
            {/if}
            <Switch
                checked={ganttCouriersSettings.useRealTime}
                label={'Real-time mode'}
                on:change={() => {
                    ganttCouriersSettings.setUseRealTime(!ganttCouriersSettings.useRealTime);
                    ganttCouriersSettings = ganttCouriersSettings;
                }}
            />
        </div>
        {#if $debug}
            <Switch
                label={$_('gantt-switch-simple-view')}
                checked={ganttCouriersSettings.visibleId}
                on:change={() => {
                    ganttCouriersSettings.toggleSimpleView();
                    ganttCouriersSettings = ganttCouriersSettings;
                }}
            />
            <Select
                items={[
                    { id: '10', label: '10' },
                    { id: '11', label: '11' },
                    { id: '12', label: '12' },
                ]}
                selected={'10'}
                onChange={s => {
                    ganttCouriersSettings.setAssignmentIds([parseInt(s)]);
                    ganttCouriersSettings = ganttCouriersSettings;
                    return true;
                }}
            />
            <Select
                items={[
                    {
                        id: GanttCouriersSettingsModeType.PLANNED,
                        label: GanttCouriersSettingsModeType.PLANNED,
                    },
                    {
                        id: GanttCouriersSettingsModeType.CURRENT,
                        label: GanttCouriersSettingsModeType.CURRENT,
                    },
                    {
                        id: GanttCouriersSettingsModeType.APPROACHED,
                        label: GanttCouriersSettingsModeType.APPROACHED,
                    },
                ]}
                selected={ganttCouriersSettings.dataMode}
                onChange={s => {
                    ganttCouriersSettings.dataMode = s;
                    ganttCouriersSettings = ganttCouriersSettings;
                    return true;
                }}
            />
        {/if}
        <GanttCouriers {ganttCouriersSettings} />
    </div>
    <div slot="footer"></div>
</TemplateStandard>
